import React from 'react';
import { Box, Typography, useTheme, Grid, Chip } from '@mui/material';
import { AttachMoney, AccountBalanceWallet, Payment } from '@mui/icons-material';
import ReactApexChart from 'react-apexcharts';

const WidgetHeader = ({ title, icon: Icon }) => {
    const theme = useTheme();
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            {Icon && <Icon sx={{ color: theme.palette.text.secondary }} />}
            <Typography variant="h6" fontWeight="bold">
                {title}
            </Typography>
        </Box>
    );
};

const FinanceAnalytics = ({ data }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const labelColor = theme.palette.text.secondary;

    const planSeries = data?.byPlan?.map(item => item.count) || [];
    const planLabels = data?.byPlan?.map(item => item._id || 'Unknown') || [];

    const paymentTypes = data?.paymentTypes || [];

    const chartOptions = {
        chart: { type: 'bar', background: 'transparent', toolbar: { show: false } },
        plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: '50%' } },
        dataLabels: { enabled: true },
        xaxis: { categories: planLabels, labels: { style: { colors: labelColor } } },
        yaxis: { labels: { style: { colors: labelColor } } },
        colors: [theme.palette.success.main],
        tooltip: { theme: isDark ? 'dark' : 'light' },
        grid: { show: false }
    };

    return (
        <Box sx={{ p: 2, borderRadius: 3, border: `1px solid ${theme.palette.divider}`, height: '100%' }}>
            <WidgetHeader title="Revenue & Subscriptions" icon={AttachMoney} />
            
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12}>
                    <Box sx={{ p: 2, bgcolor: theme.palette.primary.main, color: '#fff', borderRadius: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="body2" sx={{ opacity: 0.9 }}>Active Subscriptions</Typography>
                            <Typography variant="h4" fontWeight="bold">{data?.activeSubscriptions || 0}</Typography>
                        </Box>
                        <AccountBalanceWallet fontSize="large" sx={{ opacity: 0.8 }} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {paymentTypes.map((type, idx) => (
                             <Chip 
                                key={idx} 
                                icon={<Payment fontSize="small" />} 
                                label={`${type._id || 'Unknown'}: ${type.count}`} 
                                size="small" 
                                variant="outlined" 
                             />
                        ))}
                    </Box>
                </Grid>
            </Grid>

            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Subscriptions by Plan</Typography>
            <Box sx={{ minHeight: 200 }}>
                {planSeries.length > 0 ? (
                    <ReactApexChart options={chartOptions} series={[{ name: 'Subscribers', data: planSeries }]} type="bar" height={200} />
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                        <Typography color="text.secondary">No Data</Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default FinanceAnalytics;
